enum TagTypes {
  DEFAULT = 'DEFAULT',
  GUEST = 'GUEST',
  VISIT = 'VISIT',
}

export type TagType = 'DEFAULT' | 'GUEST' | 'VISIT';

// TODO(jacob): This belongs somewhere else.
export interface Tag {
  className?: string;
  showIcon?: boolean;
  checked?: boolean;
  isToggle?: boolean;
  type: TagType;
  val: string;
  onClick?(value: string): void;
  icon?: string;
  autoTag?: boolean;
  disabled?: boolean;
}

export default TagTypes;
